module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrap-inner",
    staticStyle: {
      "background": "#000000"
    }
  }, [_c('li', {
    staticClass: "header-left-2"
  }, [_c('a', {
    staticStyle: {
      "color": "#ffffff",
      "font-size": "20px",
      "font-weight": "500",
      "cursor": "pointer",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/"
    }
  }, [_c('logo-pad'), _c('span', {
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v("oLandigo")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "header-right-2"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('component-account-menu')], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticStyle: {
      "font-size": "22px",
      "font-weight": "400",
      "color": "#ffffff"
    },
    attrs: {
      "href": "/search"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticStyle: {
      "font-size": "22px",
      "font-weight": "bold",
      "color": "#000000",
      "background": "#ffff00",
      "padding": "0.3px",
      "border-radius": "1px"
    },
    attrs: {
      "href": "/buzz"
    }
  }, [_vm._v(" POS ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ce91a45"}!./src/pages/MainHeader/template.html
// module id = 377
// module chunks = 0